import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const FiltersWrapper = styled.div`
  margin-bottom: ${layout.measurements.spacingNormal};
`;
